import { ROUTES } from "../../../api/api.routes";
import useCustomQuery from "../../../hooks/useQuery";
import { Doc, INTERACTION_TYPE, Skill, SkillFilter, Sorted } from "../../../types";

type SkillsByType = { [t in INTERACTION_TYPE]: Doc<Skill>[] };

export const useSkills = (f?: SkillFilter) => {
  const {
    data,
    isLoading,
    mutate,
    ...rest
  } = useCustomQuery<Omit<Sorted<Doc<Skill>>, "type"> & { type: SkillsByType }>(ROUTES.Skills.All.query(f));

  return {
    skillsById: data?.byId ?? {},
    skillsByType: (data?.type as SkillsByType) ?? {},
    skills: data?.items ?? [],
    loadingSkills: isLoading,
    reloadSkills: mutate,
    ...rest
  }
}

export const useExternalSkills = () => {
  const { data, isLoading, mutate, ...rest } = useCustomQuery<Sorted<{
    id: string;
    display_title: string;
  }>>(ROUTES.Skills.External);

  return {
    externalSkills: data?.items ?? [],
    externalSkillsById: data?.byId ?? {},
    loadingExternalSkills: isLoading,
    reloadExternalSkills: mutate,
    ...rest
  }
}